/* Pages piliers (soin classique / soin profond / lissage) - ordinateur :
   les bulles de navigation sortent de la video et passent en une ligne juste sous le haut de page. */
(function () {
  var hero = document.querySelector('.gp-hero2'), ctas = hero && hero.querySelector('.gp-hero2-ctas');
  if (!ctas) return;
  var home = ctas.parentNode, next = ctas.nextSibling;
  var row = document.createElement('div'); row.className = 'pxc-navrow';
  var mq = window.matchMedia('(min-width: 769px)');
  function place() {
    if (mq.matches) { if (!row.parentNode) hero.parentNode.insertBefore(row, hero.nextSibling); row.appendChild(ctas); }
    else { home.insertBefore(ctas, next); if (row.parentNode) row.parentNode.removeChild(row); }
  }
  place(); mq.addEventListener ? mq.addEventListener('change', place) : mq.addListener(place);
})();

/* etapes en photos : texte limite a 3 lignes + "Voir plus" quand il est long (telephone et ordinateur) */
(function () {
  function setup() {
    document.querySelectorAll('.pxs-card .pxs-p').forEach(function (p) {
      if (p.dataset.vp) return; p.dataset.vp = '1';
      p.classList.add('pxs-clamp');
      var b = document.createElement('button'); b.type = 'button'; b.className = 'pxs-more'; b.textContent = 'Voir plus'; b.hidden = true;
      b.addEventListener('click', function (e) { e.stopPropagation(); e.preventDefault(); var open = p.classList.toggle('pxs-clamp') === false; b.textContent = open ? 'Voir moins' : 'Voir plus'; });
      p.parentNode.insertBefore(b, p.nextSibling);
    });
    check();
  }
  /* on ne mesure que les cartes visibles (l'onglet cache est mesure quand on l'ouvre) */
  function check() {
    document.querySelectorAll('.pxs-card .pxs-p').forEach(function (p) {
      var b = p.nextElementSibling; if (!b || !b.classList.contains('pxs-more') || !p.offsetParent) return;
      if (!p.classList.contains('pxs-clamp')) { b.hidden = false; return; }
      b.hidden = p.scrollHeight <= p.clientHeight + 2;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  window.addEventListener('load', setup);
  window.addEventListener('resize', check);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.pxs-tab')) setTimeout(check, 60); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(check);
})();

/* etapes en photos : fleches pour faire defiler (ordinateur) */
(function () {
  function init() {
    document.querySelectorAll('.pxs').forEach(function (pxs) {
      if (pxs.querySelector('.pxs-arrows')) return;
      var box = document.createElement('div'); box.className = 'pxs-arrows';
      box.innerHTML = '<button type="button" class="pxs-arr" data-d="-1" aria-label="Étape précédente"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 6l-6 6 6 6"/></svg></button><button type="button" class="pxs-arr" data-d="1" aria-label="Étape suivante"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg></button>';
      var tabs = pxs.querySelector('.pxs-tabs'); (tabs || pxs.firstChild).parentNode.insertBefore(box, tabs ? tabs.nextSibling : pxs.firstChild);
      var bs = box.querySelectorAll('.pxs-arr');
      function tr() { return pxs.querySelector('.pxs-track.is-active') || pxs.querySelector('.pxs-track'); }
      function upd() { var t = tr(); if (!t) return; bs[0].disabled = t.scrollLeft < 4; bs[1].disabled = t.scrollLeft > t.scrollWidth - t.clientWidth - 4; }
      bs.forEach(function (b) { b.addEventListener('click', function () { var t = tr(), c = t && t.querySelector('.pxs-card'); if (!t) return; t.scrollBy({ left: +b.getAttribute('data-d') * (c ? c.getBoundingClientRect().width + 16 : t.clientWidth * .8), behavior: 'smooth' }); }); });
      pxs.querySelectorAll('.pxs-track').forEach(function (t) { t.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); });
      pxs.addEventListener('click', function (e) { if (e.target.closest('.pxs-tab')) setTimeout(upd, 80); });
      upd();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* bouton "Reserver" : il flotte pendant qu'on lit, puis se gare dans son emplacement en bas de page (avant le pied de page) */
(function () {
  function init() {
    var pill = document.querySelector('.gp-sticky-cta'); if (!pill || document.querySelector('.pxc-dock')) return;
    /* tout en bas : apres la FAQ, ou apres les articles s'ils viennent apres */
    var cands = [document.querySelector('.gp-faq'), document.querySelector('.pxa')].filter(Boolean);
    var last = cands.sort(function (a, b) { return a.compareDocumentPosition(b) & 4 ? -1 : 1; }).pop() || pill.parentNode.lastElementChild;
    var dock = document.createElement('div'); dock.className = 'pxc-dock';
    var slot = document.createElement('div'); slot.className = 'pxc-dock-slot';
    /* liens vers les deux autres prestations, de chaque cote de l'emplacement du bouton */
    var P = [['lissage', '/pages/lissage-bresilien-a-lyon', 'Découvrez nos lissages'], ['profond', '/pages/soin-profond-a-lyon', 'Découvrez nos soins profonds'], ['classique', '/pages/soin-classique-a-lyon', 'Découvrez nos soins classiques']];
    var here = location.pathname, others = P.filter(function (x) { return here.indexOf(x[1]) !== 0; }).slice(0, 2);
    function link(x, side) { var a = document.createElement('a'); a.className = 'pxc-dock-link pxc-dock-link--' + side; a.href = x[1]; a.innerHTML = (side === 'l' ? '<span aria-hidden="true">←</span>' : '') + '<span>' + x[2] + '</span>' + (side === 'r' ? '<span aria-hidden="true">→</span>' : ''); return a; }
    /* telephone avec photo de fin (.pxb) : le bouton se pose en bas de la photo (script de la page),
       les deux liens vont sous la photo */
    var pxb = document.querySelector('.pxb');
    if (pxb && window.matchMedia('(max-width: 768px)').matches) {
      dock.classList.add('pxc-dock--mob');
      if (others[0]) dock.appendChild(link(others[0], 'l'));
      if (others[1]) dock.appendChild(link(others[1], 'r'));
      var after = pxb.closest('.shopify-section') || pxb;
      after.parentNode.insertBefore(dock, after.nextSibling);
      return;
    }
    if (others[0]) dock.appendChild(link(others[0], 'l'));
    dock.appendChild(slot);
    if (others[1]) dock.appendChild(link(others[1], 'r'));
    last.parentNode.insertBefore(dock, last.nextSibling);
    var home = pill.parentNode, next = pill.nextSibling, docked = false, raf = 0;
    function gap() { return window.matchMedia('(min-width: 769px)').matches ? 26 : 30; }
    function upd() {
      raf = 0;
      var h = pill.offsetHeight || 64; slot.style.minHeight = h + 'px';
      var should = slot.getBoundingClientRect().top + h <= window.innerHeight - gap();
      if (should && !docked) { slot.appendChild(pill); pill.classList.add('is-docked'); docked = true; }
      else if (!should && docked) { home.insertBefore(pill, next); pill.classList.remove('is-docked'); docked = false; }
    }
    function req() { upd(); }
    window.addEventListener('scroll', req, { passive: true }); window.addEventListener('resize', req); upd();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
